import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import api, { apiErrorMessage } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    const token = localStorage.getItem("sgc_token");
    const username = localStorage.getItem("sgc_username");
    const role = localStorage.getItem("sgc_role");
    return token ? { token, username, role } : null;
  });

  const login = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("sgc_token", data.access_token);
    localStorage.setItem("sgc_username", data.username);
    localStorage.setItem("sgc_role", data.role);
    setAuth({ token: data.access_token, username: data.username, role: data.role });
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("sgc_token");
    localStorage.removeItem("sgc_username");
    localStorage.removeItem("sgc_role");
    setAuth(null);
  }, []);

  const changePassword = useCallback(async (newPassword) => {
    await api.post("/auth/change-password", { new_password: newPassword });
  }, []);

  const isSupervisor = auth?.role === "supervisor";

  const value = useMemo(
    () => ({ auth, login, logout, changePassword, isSupervisor, apiErrorMessage }),
    [auth, login, logout, changePassword, isSupervisor]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
